/* global windowWidth, breakpointSm */
const tooltips = document.querySelectorAll('.tooltip');

tooltips.forEach((tooltip) => {
  const tooltipQuestion = tooltip.querySelector('.tooltip__question');
  const tooltipText = tooltip.querySelector('.tooltip__text__wrapper');
  const tooltipClose = tooltip.querySelector('.tooltip__close');

  // Open tooltip
  tooltipQuestion.addEventListener('click', () => {
    tooltipText.classList.add('is-open');
  });

  // Close tooltip
  tooltipClose.addEventListener('click', () => {
    tooltipText.classList.remove('is-open');
  });

  // **************************************************

  if (windowWidth() < breakpointSm) {
    const tooltipArrow = tooltip.querySelector('.tooltip__arrow');
    const viewportOffset = tooltip.getBoundingClientRect();
    const tooltipOffset = viewportOffset.left;

    // Give tooltip text negative margin on mobile so it's always centered
    tooltipText.style.marginLeft = `-${tooltipOffset}px`;
    tooltipArrow.style.marginLeft = `${tooltipOffset}px`;
  };
});
